import React, { createContext, useContext, useCallback } from "react";
import { useEventHandler } from "@/shared/hooks/events/useEventHandler";

export interface Event {
  type: string;
  params?: Record<string, any>;
  customOptions?: Record<string, any>;
}

interface EventContextType {
  emitEvent: (event: Event) => void;
}

export const EVENT_TYPES = {
  PROJECTS_LIST_VIEW: "PROJECTS_LIST_VIEW",
  PROJECT_DETAILS_VIEW: "PROJECT_DETAILS_VIEW",
  PERSON_VIEW: "PERSON_VIEW",
};

const EventContext = createContext<EventContextType | undefined>(undefined);

export const EventProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  useEventHandler();
  const emitEvent = useCallback((event: Event) => {
    // Create a custom event and dispatch it
    const customEvent = new CustomEvent("app-event", {
      detail: event,
      bubbles: true,
    });
    window.dispatchEvent(customEvent);
  }, []);

  return (
    <EventContext.Provider value={{ emitEvent }}>
      {children}
    </EventContext.Provider>
  );
};

export const useEvent = () => {
  const context = useContext(EventContext);
  if (context === undefined) {
    throw new Error("useEvent must be used within an EventProvider");
  }
  return context;
};
